import { useSnackbar } from "notistack";
import { useForm } from "react-hook-form";

import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRemoveUserWithIdMutation } from "../../../../../user/userApiSlice";

const RemoveDialog = ({ onClose, open, userId }) => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const [removeUser, { isLoading }] = useRemoveUserWithIdMutation();

	const { handleSubmit, setError } = useForm({
		// resolver: yupResolver(formSchema),
		shouldFocusError: true,
	});

	const handleRemoveUser = async () => {
		await removeUser({ userId })
			.unwrap()
			.then((_payload) => {
				enqueueSnackbar(t("removed_user"), {
					variant: "success",
				});
				onClose();
			})
			.catch((error) => {
				if (error?.data?.errors) {
					const errors = error.data.errors;
					Object.entries(errors).forEach(([key, message]) => {
						setError(key);
						enqueueSnackbar(message[0], {
							variant: "error",
							preventDuplicate: true,
						});
					});
				} else {
					enqueueSnackbar(error?.data?.message || t("default_error"), {
						variant: "error",
						preventDuplicate: true,
					});
				}
			});
	};

	return (
		<Dialog
			fullWidth
			sx={{ maxWidth: "450px", mx: "auto" }}
			onClose={onClose}
			open={open}
		>
			<Box sx={{ padding: "30px" }}>
				<Box component="form" onSubmit={handleSubmit(handleRemoveUser)}>
					<Grid container spacing={1.5}>
						<Grid sx={{ textAlign: "center", mb: 2 }} size={12}>
							<Typography variant="h3" component="span">
								{t("are_you_sure")}
							</Typography>
						</Grid>
						<Grid size={6}>
							<Button
								type="submit"
								loading={isLoading}
								fullWidth
								variant="contained"
							>
								{t("remove")}
							</Button>
						</Grid>
						<Grid size={6}>
							<Button fullWidth variant="contained" onClick={onClose}>
								{t("cancel")}
							</Button>
						</Grid>
					</Grid>
				</Box>
			</Box>
		</Dialog>
	);
};

export default RemoveDialog;
